import React , {Component } from 'react';
import M from 'materialize-css';
import logo from '../img/ceaweb.png';
import '../App.css';
import { Link } from 'react-router-dom';

class Navbar extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    componentDidMount(){
        M.AutoInit();
        let op=this.props.opcion;
        console.log(op)
        document.getElementById(op).style.borderBottom = "1px solid #0095C5";
    }
    render() {
        return(
            <div id="inicio">
                    <div className="row rowsinmag preheader">
                        <p className="ppreheader white-text"><span class="material-icons white-text">phone</span>444 5802</p>
                        
                        <p className="ppreheader hide-on-med-and-down white-text"><span class="material-icons white-text">stay_current_portrait</span>304 618 8902</p>
                        
                        <p className="ppreheader hide-on-med-and-down white-text"><span class="material-icons white-text">room</span>Calle 104 # 68 A - 77</p>

                        <a href="https://www.mipagoamigo.com/MPA_WebSite/ServicePayments/StartPayment?id=1709&searchedCategoryId=&searchedAgreementName=COLEGIO%20CENTRO%20EDUCATIVO%20AUTONOMO" target="_blank"><p className="ppreheader white-text"><span class="material-icons white-text">payment</span>Ir a Mi Pago Amigo</p></a>
                        
                    </div>

                    {/* menu NavBar para equipos de escritorio */}
                    <nav className="z-depth-0 white">
                        <div className="nav-wrapper banner flow-text white">
                            <img src={logo} alt="CEA" className="imgprin"/>
                            <a href="#" data-target="mobile-demo" className="sidenav-trigger black-text"> <i className="material-icons">menu</i> </a>
                            <ul className="right hide-on-med-and-down">
                                <li><Link id="op1" to={'/'} className="black-text menu">Home</Link></li>
                                <li><Link id="op2" to={'/colegio'} className="black-text menu">El Colegio</Link></li>
                                <li><Link id="op3" to={'/proyectos'} className="black-text menu">Proyectos</Link></li>
                                <li><Link id="op4" to={'/admisiones'} className="black-text menu">Admisiones</Link></li>
                                <li><a id="op5" href="https://www.instagram.com/ceautonomo/" target="_blank" className="black-text menu">Galeria</a></li>
                                <li><a href="https://autonomo.ieduca2.com/login" className="ahelper" target="_blank"><p className="helper valign-wrapper z-depth-1">iEduca</p></a></li>
                                
                            </ul>
                        </div>
                    </nav>

                    {/* Menu NavBar para moviles */}
                    <ul className="sidenav" id="mobile-demo">
                        <li> <Link to={'/'} className="menu">Home</Link> </li>
                        <li> <Link to={'/colegio'} className="menu">El Colegio</Link> </li>
                        <li> <Link to={'/proyectos'} className="menu">Proyectos</Link> </li>
                        <li> <Link to={'/admisiones'} className="menu">Admisiones</Link> </li>
                        <li> <a href="https://www.instagram.com/ceautonomo/" target="_blank" className="menu">Galeria</a> </li>
                        <li> <a href="https://autonomo.ieduca2.com/login" className="ahelper white-text" target="_blank"><p className="helper valign-wrapper">Acceso iEduca</p></a></li>
                    </ul>
            </div>
        );
    }
}

export default Navbar;